import { Type } from "./Type";
import { FormFields } from "../index";
import { ObjField } from "./ObjectFieldComponent";
import { FieldRenderProps } from "react-final-form";
import React from "react";

export interface ObjectFieldProps extends FormFields {}

export const ObjectField = (options: ObjectFieldProps) =>
  new Type({
    PresentationComponent: (props: FieldRenderProps<any>) => {
      const v = JSON.stringify(props.input.value);
      return <>{v}</>;
    },
    Component: ObjField as any,
    props: { schema: options }
  });
